import React from 'react';
import { Spinner } from 'react-bootstrap';


const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '100vh' }}>
      <Spinner animation="grow" role="status" variant='info'>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loader;